import React, { useEffect, useState } from "react";
import Pagination from "../Others/Pagination";
import { acceptConge, getAllCongeByCode, getAllDemandeCongeByCode, getAllDemandeCongeByUser, senFcmConge, sentCongeEmail } from "../../Services/Pointeuse/CongeApi";
import CustomSyncLoader from "../Others/CustomSyncLoader";
import ErrorCustum from "../Others/ErrorCustum";
import { Link } from "react-router-dom";
import firebase from "../../firebase";
import TableConges from "./TableConges";
import { filterCongeByWord } from "../../Utils/SortObject";
import { addNumberToDate, dateBetweenTwoDates } from "../../Utils/DateUtils";
import ImageComponent from "../Styles/ImageComponent";
import { getEntrepriseByCode, getExercice } from "../../Services/Pointeuse/EntrepriseApi";
import ButtonHeaderComponent from "../Styles/ButtonHeaderComponent";
import CongeCardHeader from "./CongeCardHeader";
import swal from "sweetalert";
import ExportCsv from "../Exports/ExportCsv";
import ExportPdf from "../Exports/ExportPdf";
import CopieContent from "../Exports/CopieContent";
import { useTranslation } from 'react-i18next'; // Importez le hook useTranslation
import AddConge from "./AddConge";

function DemandeCongesUser() {
  const { t } = useTranslation(); // Utilisez le hook useTranslation pour obtenir la fonction de traduction t
  const [currentData, setcurrentData] = useState([]);
  const [allInitialData, setallInitialData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setdata] = useState([]);
  const [dateStart, setdateStart] = useState("");
  const [dateEnd, setdateEnd] = useState("");
  const [size, setsize] = useState(8);
  const [logo, setlogo] = useState(null);
  const [isCollapsed, setisCollapsed] = useState(false);
  const [exercice, setexercice] = useState();
  const [selectedexercice, setselectedExercice] = useState();
  const [totaux, settotaux] = useState();
  const [soldeConge, setsoldeConge] = useState();

  useEffect(() => {
    getExercice().then((res) => {
      if (Array.isArray(res?.data)) {
        setexercice(res.data);
        setselectedExercice(res.data[0].code_exercice)

      }
    })
  }, [])

  useEffect(() => {
    getEntrepriseByCode().then((res) => {
      setlogo(res.data.logo);
    });
  }, []);

  /**
   * It gets all the data from the API and sets it to the data variable.
   */
  const getData = () => {
    setLoading(true);
    getAllDemandeCongeByUser(selectedexercice)
      .then((res) => {
        setdata(res.data.demandes);
        settotaux(res.data.totaux)
        setallInitialData(res.data.demandes);
        setsoldeConge(res.data.listSolde)
      })
      .catch((error) => setError(error))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getData();
  }, [selectedexercice]);

  const removeObject = (id) => {
    const updatedData = allInitialData.filter((item) => item.id != id);
    setdata(updatedData);
    setallInitialData(updatedData);
  };

  /**
   * The function takes in a page of items and sets the currentData state to that page of items
   * @param pageOfItems - an array of items on the current page.
   */
  const onChangePage = (pageOfItems) => {
    // update state with new page of items
    setcurrentData(pageOfItems);
  };
  /**
   * It filters the data by the search word.
   * @param e - The event object that contains the value of the search input.
   */
  const handleSearch = (e) => {

    if (e.target.value !== "") {
      const dataSearch = filterCongeByWord(allInitialData, e.target.value);
      setcurrentData(dataSearch);
    } else {
      setcurrentData(allInitialData);
    }
  };
  /**
   * filter conges by date
   */
  const handleSearchBydate = () => {
    const filtredDate = dateBetweenTwoDates(dateStart, dateEnd, allInitialData);
    setdata(filtredDate);
  };

  /**
   * The function sets the size of the data to be retrieved from the API.
   * @param e - The event object that contains the data we want to use.
   */
  const handleChangeSize = (e) => {
    setsize(e.target.value);
    getData();
  };

  /**
   * Accept a leave request
   * @param receiver - The email address of the user who is going to receive the notification.
   * @param nom - The name of the user who sent the request.
   * @param prenom - The first name of the user who sent the request.
   * @param nbjour - Number of days of the leave
   * @param motif - The reason for the leave
   * @param id - The id of the conge you want to accept.
   * @param type - The type of the notification.
   * @param date - The date of the conge.
   * @param status - The status of the leave request.
   * @param userid - The id of the user who sent the request.
   */
  const handleAccept = (receiver, nom, prenom, nbjour, motif, id, type, date, status, userid) => {
    swal({
      title: t("Ëtes-vous sûr ?"),
      text: t("Voulez vous vraiment accepté congé!"),
      icon: "warning",
      // buttons: true,
      buttons: {
        cancel: t("Cancel"), // Traduisez le bouton "Cancel"
        confirm: {
          text: t("OK"), // Traduisez le bouton "OK"
          value: true,
        },
      },
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        acceptConge(id, nbjour, "1").then(() => {
          //toast.success("Congé accepté");
          sentCongeEmail(receiver, nom, prenom, nbjour, motif, logo, id, type, date, status).then(() => {
            swal(t("Opération effectuée avec succès!"), {
              icon: "success",
            });
            //remove from list
            const updatedData = allInitialData.filter((item) => item.id != id);
            setdata(updatedData);
            setallInitialData(updatedData);
            //getData();
            sendFirebaseNotification(status, userid);
          });
        });
      }
    });
  };

  /**
   * It sends a notification to the user.
   * @param type - The type of notification to send.
   * @param receiver - The user's device token.
   */
  const sendFirebaseNotification = (type, receiver) => {
    const messaging = firebase.messaging();
    messaging
      .requestPermission()
      .then(() => {
        return messaging.getToken();
      })
      .then(() => {
        senFcmConge(type, receiver);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  /**
   * It sends a notification to the user who requested the leave.
   * @param id - The id of the leave request
   * @param nbjour - number of days of the leave
   * @param receiver - The user who will receive the notification.
   */

  const handleReject = (id, nbjour, receiver) => {
    swal({
      title: t("Ëtes-vous sûr ?"),
      text: t("Voulez vous vraiment refusé congé!"),
      icon: "warning",
      // buttons: true,
      buttons: {
        cancel: t("Cancel"), // Traduisez le bouton "Cancel"
        confirm: {
          text: t("OK"), // Traduisez le bouton "OK"
          value: true,
        },
      },
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        acceptConge(id, nbjour, "0").then(() => {
          //toast.success("Congé accepté");
          swal(t("Opération effectuée avec succès!"), {
            icon: "success",
          });
          const updatedData = allInitialData.filter((item) => item.id != id);
          setdata(updatedData);
          setallInitialData(updatedData);
          sendFirebaseNotification(t("refusé"), receiver);
        });
      }
    });
  };

  /**
   * *This function is used to toggle the collapse state of the sidebar.*
   */
  const handleCollapse = () => {
    setisCollapsed(!isCollapsed);
  };
  const sum = (value1, value2, value3) => {
    return value1 + value2 + value3;
  };
  return (
    <>
      <>
        <div className="page-header d-xl-flex d-block">
          <div className="page-leftheader">
            <h4 className="page-title">{t("Congé")}</h4>
          </div>
          <div className="page-rightheader ml-md-auto">
            <div className="align-items-end flex-wrap my-auto right-content breadcrumb-right">
              <div className="btn-list">
                <Link to="#" className="btn btn-primary mr-3" data-toggle="modal" data-target="#addCongeModal">
                  {t("Ajouter congé")}
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12 col-md-12 col-lg-12">
            <div className="card">
              <div className="card-body">
                <div className="row mb-0 pb-0 d-flex justify-content-center">
                  <div className="col-md-6 col-lg-2 text-center py-5">
                    <h5 className="mb-0 mt-3">{t("Exercice")}</h5>

                    <select className="form-control" value={selectedexercice} onChange={(e) => setselectedExercice(e.target.value)}>
                      {exercice && exercice?.map((item, index) => (
                        <option key={index} value={item.id}>
                          {item.code_exercice}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-6 col-lg-2 text-center py-5">
                    <span className="avatar avatar-md bradius fs-20 bg-primary-transparent">
                      {sum(totaux?.totalDemandes, totaux?.totalCongesRefuses, totaux?.totalCongesValides)}
                    </span>
                    <h5 className="mb-0 mt-3">{t("Total congés")}</h5>
                  </div>
                  <div className="col-md-6 col-lg-2 text-center py-5">
                    <span className="avatar avatar-md bradius fs-20 bg-success-transparent">{totaux?.totalCongesValides}</span>
                    <h5 className="mb-0 mt-3">{t("Total validés")}</h5>
                  </div>
                  <div className="col-md-6 col-lg-2 text-center py-5 ">
                    <span className="avatar avatar-md bradius fs-20 bg-danger-transparent">{totaux?.totalCongesRefuses}</span>
                    <h5 className="mb-0 mt-3">{t("Total non validés")}</h5>
                  </div>
                  <div className="col-md-6 col-lg-2 text-center py-5">
                    <span className="avatar avatar-md bradius fs-20 bg-warning-transparent">{totaux?.totalDemandes}</span>
                    <h5 className="mb-0 mt-3">{t("Total demandes")}</h5>
                  </div>
                </div>


              </div>
            </div>
          </div>
        </div>
        <AddConge getData={getData} exercice={selectedexercice} />
      </>
      <div className="row">
        <div className="col-xl-9 col-md-12 col-lg-12">
          <div className={isCollapsed ? "card  card-fullscreen" : "card"}>
            <div className="card-header  border-0">
              <h4 className="card-title">{t("Liste des congés")}</h4>
              <div className="card-options">
                <Link to="#" className="card-options-fullscreen mr-2" data-toggle="card-fullscreen" onClick={handleCollapse}>
                  <i className="fe fe-maximize" />
                </Link>
              </div>
            </div>

            <div className="card-body">
             
              {loading && <CustomSyncLoader></CustomSyncLoader>}
              {!loading && error && <ErrorCustum></ErrorCustum>}
              {!loading && !error && data && (
                <div className="table-responsive">
                  <div id="hr-table_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer">
                    <div className="row">
                      <div className="col-sm-12 col-md-6">
                        <div className="dataTables_length" id="hr-table_length">
                          <label>
                            {t("Afficher")}{" "}
                            <select value={size} className="form-control" id="exampleFormControlSelect1" onChange={handleChangeSize}>
                              <option value={8}>8</option>
                              <option value={20}>20</option>
                              <option value={40}>40</option>
                              <option value={60}>60</option>
                              <option value={100}>100</option>
                            </select>{" "}
                            {t("entrées")}
                          </label>
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-6">
                        <div id="hr-table_filter" className="dataTables_filter">
                          <label className="mr-2">
                            <input
                              type="search"
                              className="form-control"
                              placeholder={t("Recherche...")}
                              aria-controls="hr-table"
                              onChange={handleSearch}
                            />
                          </label>


                          <CopieContent />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">


                        <table className="table table-vcenter text-nowrap table-bordered border-bottom dataTable no-footer">
                          <thead>
                            <tr>
                              <th className="border-bottom-0 w-5"></th>
                              <th className="border-bottom-0 w-5">{t("motif congé")}</th>
                              <th className="border-bottom-0 w-5">{t("Affect solde")}</th>

                              <th className="border-bottom-0 w-5">{t("De")}</th>
                              <th className="border-bottom-0 w-5">{t("à")}</th>
                              <th className="border-bottom-0 w-4">{t("Nb-J")}</th>
                              <th className="border-bottom-0 w-5">{t("Statut")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {currentData.map((el) => (
                              <tr key={el.id}>
                                <td>
                                  <div className="d-flex">
                                    <ImageComponent picture={el.imguser} atr={"avatar avatar-md brround mr-3"}></ImageComponent>
                                    <div className="mr-8 mt-0 mt-sm-1 d-block">
                                      <h6 className="mb-1 fs-14">
                                        {el.nom} {el.prenom}
                                      </h6>
                                      <p className="text-muted mb-0 fs-12">{el.email}</p>
                                    </div>
                                  </div>
                                </td>

                                <td data-toggle="modal" data-target="#modalMotif" style={{ cursor: "pointer" }}>
                                  {t(el.motif)}<i className="feather feather-edit text-info"></i>
                                </td>
                                <td>
                                  {el.affect_solde === 1 && <i className="fa fa-check-circle text-success"></i>}

                                </td>
                                <td>{el.date.split("T")[0]}</td>
                                <td>{addNumberToDate(el.nbr_jour, el.date)}</td>
                                <td>{el.nbr_jour}</td>
                                {/* {status} */}
                                <td className="text-center">
                                  {(el.type === "conge" && el.valide === 0) ? (
                                    <span className="badge badge-danger">{t("refusé")}</span>
                                  ) : (el.type === "demande") ? (
                                    <span className="badge badge-warning">{t("demande")}</span>
                                  ) : (
                                    <span className="badge badge-success">{t("accepté")}</span>
                                  )}
                                </td>



                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 col-md-5">
                        <div className="dataTables_info" id="hr-table_info" role="status" aria-live="polite">
                          {t("Affichage")} {t("de")} 1 {t("à")} {size} {t("sur")} {data.length} {t("entrées")}
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-7">
                        <Pagination items={data} onChangePage={onChangePage} pageSize={size} />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-md-12 col-lg-12">
          <div className="card">
            <div className="card-header border-0">
              <h4 className="card-title">{t("Solde congé")}</h4>
            </div>

            <div className="card-body">
              {soldeConge && soldeConge.length > 0 ? (
                <ul className="list-group list-group-flush">
                  {soldeConge.map((el, idx) => {
                    const label = Object.keys(el)[0];
                    const value = el[label];
                    return (
                      <li
                        key={idx}
                        className="list-group-item d-flex justify-content-between align-items-center py-3"
                        style={{
                          backgroundColor: idx % 2 === 0 ? "#f8f9fa" : "#ffffff",
                          borderRadius: "8px",
                          marginBottom: "6px",
                          boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                        }}
                      >
                        <div className="text-start">
                          <span className="fw-semibold text-secondary" style={{ fontSize: "15px" }}>
                            {t(label)}
                          </span>
                        </div>
                        <span
                          className="badge rounded-pill text-white"
                          style={{
                            backgroundColor:
                              label.toLowerCase().includes("maladie")
                                ? "#dc3545" // rouge
                                : label.toLowerCase().includes("annuel")
                                  ? "#0d6efd" // bleu
                                  : "#198754", // vert par défaut
                            fontSize: "16px",
                            padding: "10px 14px",
                            minWidth: "50px",
                          }}
                        >
                          {value}
                        </span>
                      </li>
                    );
                  })}
                </ul>
              ) : (
                <p className="text-center text-muted mb-0">{t("Aucun solde disponible")}</p>
              )}
            </div>

          </div>
        </div>


      </div>
    </>
  );
}

export default DemandeCongesUser;
